window.generateUUID = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  /* eslint-disable prefer-template */
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};

window.isValidEmail = (email) => {
  const pattern =
    // eslint-disable-next-line vue/max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email);
};

window.isValidMobile = (mobile) => {
  if (mobile === undefined || mobile === null) {
    return false;
  }

  if (String(mobile).length !== 10) {
    return false;
  }

  return String(mobile).startsWith("04");
};

// Find the index of an object (needle) in a given array (haystack), by a given object key/property
window.findIndexById = (haystack, needle, key) => {
  let property = key;
  if (key === undefined) {
    property = "id";
  }

  return haystack.map((object) => object[property]).indexOf(needle[property]);
};
